import React from "react"
import {
  iconColorCss,
  type IconProps,
  iconSizeCss,
} from "@myvp/shared/src/styles/icon-utils"

const Trash = (props: IconProps) => (
  <svg
    className={props.className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={[iconSizeCss("medium"), iconColorCss(props.color)]}
  >
    <path d="M9 10V17H10V10H9Z" fill="var(--color)" />
    <path d="M14 10V17H15V10H14Z" fill="var(--color)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3C7.89543 3 7 3.89543 7 5V6H4V8H5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8H20V6H17V5C17 3.89543 16.1046 3 15 3H9ZM7 19V8H17V19H7ZM9 7H15V5H9V7Z"
      fill="var(--color)"
    />
  </svg>
)

export default Trash
